<template>
  <div>
    <div v-if="isH5 == false" class="home home-pc">
      <pheader activeIndex="Home"></pheader>
      <el-container>
        <el-main class="home-pc-main">
          <el-row>
            <el-col>
              <search @searchContentList="startSearch"></search>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <div class="home-list-shell ibp-major-content-shell">
                <search-page :searchParam="queryObject" ref="searchPageRef"></search-page>
              </div>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
      <pfooter></pfooter>
    </div>
    <div v-else class="home">
      <pheader activeIndex="Home" />
      <van-row>
        <search @searchContentList="startSearch" :is_h5="isH5" :is_top="showH5Title"></search>
      </van-row>
      <van-row>
        <search-page :searchParam="queryObject" ref="searchPageRef" :is_h5="isH5"></search-page>
      </van-row>
    </div>
    <ai-search-component :isisShow="isisShow"></ai-search-component>
    <div
      class="ibp-h5-ai-fab"
      role="button"
      tabindex="0"
      aria-label="打开课程助手"
      @click="clickAIButton($event)"
      @keydown.enter.prevent="clickAIButton($event)"
    >
      <div class="ibp-h5-ai-fab__inner">
        <el-image class="ibp-h5-ai-fab__img" fit="contain" :src="require('@/assets/hcvt.png')" />
        <p class="ibp-h5-ai-fab__label">课程助手</p>
      </div>
    </div>
  </div>
</template>


<script>
import pheader from "@/views/pheader.vue";
import pfooter from "@/views/pfooter.vue";
import search from "@/components/search.vue";
import searchPage from "@/components/search-page.vue";
import aiSearchComponent from "@/components/ai-search-component.vue";
export default {
  name: 'homeIndex',
  components: {
    pheader,
    pfooter,
    search,
    searchPage,
    aiSearchComponent,
  },
  props: {
  },
  setup(){
    return {
      title: "海职院教学资源平台",
      activeIndex:'1'
    }
  },
  data(){
    return {
      showH5Title:false,
      isH5:false,
      queryObject:{},
      isisShow:0
    }
  },
  mounted(){
    // 添加窗口大小变化的事件监听器
    window.addEventListener('resize', this.checkScreenSize);
    // 初始化时检查屏幕大小
    this.checkScreenSize();
  },
  methods:{
    clickAIButton(){
      this.isisShow +=1
    },
    checkScreenSize() {
      // 使用媒体查询判断屏幕大小
      this.isH5 = this.$utils.checkScreenSize();
    },
    handleSelect(key, keyPath){
      console.log(key, keyPath)
      if (key.startsWith('Home')){
        key = 'Home'
      }
      let routeUrl = this.$router.resolve({
        path: "/" + key
      });
      // window.open(routeUrl.href, '_blank');
      if (key.startsWith('http')){
        window.open(key, '_blank');
      }else{
        window.location.href = routeUrl.href
      }
    },
    startSearch(queryObject) {
      if (queryObject) {
        let mergedDict = { ...this.queryObject, ...queryObject };
        this.queryObject = mergedDict;
      }
    },
  },
  beforeUnmount() {
    // 在组件销毁前移除事件监听器
    window.removeEventListener('resize', this.checkScreenSize);
  }
}
</script>

<style scoped>
/* 与 courseMajorDisplay 专业课程页主区：同系渐变底 + 正文字体栈 */
.home-pc {
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', system-ui, -apple-system,
    'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
}

.home-pc-main {
  --major-nav-blue: #175cc4;
  --major-page-bg: #e8f1fb;
  --major-page-bg-mid: #eef4fb;
  --major-page-bg-soft: #f4f8fc;
  background: linear-gradient(
    180deg,
    var(--major-page-bg) 0%,
    var(--major-page-bg-mid) 42%,
    var(--major-page-bg-soft) 100%
  );
  padding-bottom: 48px;
}

.home .content {
  max-width: 80%;
  margin: 0 auto;
}

.el-main {
  --el-main-padding: 0px;
  overflow: unset;
}

/* 与顶部检索条同宽（见 global.css .ibp-major-content-shell） */
.home-list-shell {
  margin-top: 8px;
  padding-top: 4px;
}

@media screen and (max-width: 1400px) {
  .col-content2 {
    background-position: center;
    max-width: 1100px;
  }

  .home .content2 {
    max-width: 1920px;
    margin: 0 auto;
  }
}
</style>
